import {
  Component,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  EventEmitter,
} from "@angular/core";
import { FeatureItem } from "../../model/feature-item";
import { ShopWindowItem } from "../../model/shop-window-item";

@Component({
    selector: "pme-comparative-sdsn",
    templateUrl: "./comparative-sdsn.component.html",
    styleUrls: ["./comparative-sdsn.component.scss"],
    standalone: false
})
export class ComparativeSdsnComponent implements OnInit, OnChanges {
  @Input() shopWindowItems: ShopWindowItem[] = [];
  @Output() clickOnProduct = new EventEmitter<number>();
  featureNames: any[] = [];
  featureItems: any = {};

  showTable = false;
  textButton: string;
  animation = "close";
  btnIcon = "arrow_downward";

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    let features = this.shopWindowItems.reduce((acc, item) => {
      item.featureList.forEach((feature) => {
        if (!acc[feature.name]) {
          acc[feature.name] = feature;
        }
      });
      return acc;
    }, {});
    this.featureNames = Object.keys(features);
    this.featureItems = features;
    this.textButton = this.shopWindowItems.length > 1 ? "Comparar funcionalidades de cada plano" : "Funcionalidades do plano";
  }

  getIcon(feature: FeatureItem): string {
    if (feature?.icon === "done") {
      return "check";
    } else {
      return "close";
    }
  }

  hasTooltip() {
    for (const item of this.shopWindowItems) {
      for (const feature of item.featureList) {
        if (feature?.tooltip != null) {
          return true;
        }
      }
    }
    return false;
  }

  getTooltip(){
    for (const item of this.shopWindowItems) {
      for (const feature of item.featureList) {
        if(this.hasTooltip()){
          return feature.tooltip
        }
      }
    }
  }

  onOpenTableClick() {
    if (this.showTable) {
      this.animation = "close";
      if (this.shopWindowItems.length > 1) {
        this.textButton = "Comparar funcionalidades de cada plano";
      } else {
        this.textButton = "Funcionalidades do plano";
      }
      this.btnIcon = "arrow_downward";

      setTimeout(() => {
        this.showTable = false;
      }, 1000);
    } else {
      this.showTable = true;
      if (this.shopWindowItems.length > 1) {
        this.textButton = "Fechar comparativo";
      } else {
        this.textButton = "Fechar";
      }
      this.btnIcon = "close";

      setTimeout(() => {
        this.animation = "open";
      });
    }
  }

  onClick(index: number): void {
    this.clickOnProduct.emit(index);
  }
}
